import { Link } from 'react-router-dom';
import styles from './Legal.module.css';

export function Privacy() {
  return (
    <div className={styles.page}>
      <nav className={styles.nav}>
        <Link to="/" className={styles.logo}>
          <span className={styles.logoAccent}>E</span>bombo
        </Link>
        <Link to="/" className={styles.backLink}>
          Back to Home
        </Link>
      </nav>

      <div className={styles.container}>
        <h1 className={styles.title}>Privacy Policy</h1>
        <p className={styles.lastUpdated}>Last updated: March 27, 2026</p>

        <div className={styles.section}>
          <h2 className={styles.sectionTitle}>1. Information We Collect</h2>
          <p className={styles.text}>
            Ebombo Technologies ("we", "our", "us") collects information you provide when using our
            platform, including:
          </p>
          <ul className={styles.list}>
            <li>Account information (name, email address, company name)</li>
            <li>Event data you enter (event details, client information, budgets)</li>
            <li>Chat messages and AI-generated quotations</li>
            <li>Provider information and service catalogs</li>
            <li>Usage data and analytics (pages visited, features used)</li>
            <li>Device and browser information for security purposes</li>
          </ul>
        </div>

        <div className={styles.section}>
          <h2 className={styles.sectionTitle}>2. How We Use Your Information</h2>
          <p className={styles.text}>We use your information to:</p>
          <ul className={styles.list}>
            <li>Provide and improve our event management platform</li>
            <li>Generate AI-powered quotations and recommendations</li>
            <li>Process and manage provider databases</li>
            <li>Send service-related communications</li>
            <li>Ensure platform security and prevent fraud</li>
            <li>Comply with legal obligations</li>
          </ul>
        </div>

        <div className={styles.section}>
          <h2 className={styles.sectionTitle}>3. AI and Data Processing</h2>
          <p className={styles.text}>
            Our platform uses AI services (including Anthropic Claude and Google Gemini) to generate
            quotations, analyze documents, and create presentations. Data sent to these services is
            processed according to their respective privacy policies and is not used to train their
            models.
          </p>
        </div>

        <div className={styles.section}>
          <h2 className={styles.sectionTitle}>4. Data Sharing</h2>
          <p className={styles.text}>
            We do not sell your personal data. We may share information with:
          </p>
          <ul className={styles.list}>
            <li>Cloud infrastructure providers (Google Cloud, Railway, Vercel) for hosting</li>
            <li>AI service providers for quotation and content generation</li>
            <li>Law enforcement when required by applicable law</li>
          </ul>
        </div>

        <div className={styles.section}>
          <h2 className={styles.sectionTitle}>5. Data Security</h2>
          <p className={styles.text}>
            We implement industry-standard security measures including encrypted data transmission
            (TLS), secure authentication (JWT), rate limiting, and access controls. All passwords
            are hashed and never stored in plain text.
          </p>
        </div>

        <div className={styles.section}>
          <h2 className={styles.sectionTitle}>6. Data Retention</h2>
          <p className={styles.text}>
            We retain your data for as long as your account is active. Upon account deactivation,
            your data is retained for up to 90 days before permanent deletion, unless required by
            law to retain it longer.
          </p>
        </div>

        <div className={styles.section}>
          <h2 className={styles.sectionTitle}>7. Your Rights</h2>
          <p className={styles.text}>You have the right to:</p>
          <ul className={styles.list}>
            <li>Access your personal data</li>
            <li>Request correction of inaccurate data</li>
            <li>Request deletion of your data</li>
            <li>Export your data in a portable format</li>
            <li>Withdraw consent for data processing</li>
          </ul>
        </div>

        <div className={styles.section}>
          <h2 className={styles.sectionTitle}>8. Cookies</h2>
          <p className={styles.text}>
            We use essential cookies for authentication and session management. We do not use
            third-party tracking cookies or advertising cookies.
          </p>
        </div>

        <div className={`${styles.section} ${styles.contact}`}>
          <h2 className={styles.sectionTitle}>Contact Us</h2>
          <p className={styles.text}>
            For privacy-related inquiries, contact us at{' '}
            <a href="mailto:tech@ebombo.com">tech@ebombo.com</a>.
          </p>
        </div>
      </div>
    </div>
  );
}
